import React from 'react';
import useData from '@/utils/useData';
import CellLoader from '@/components/loading/CellLoader';
import StoryboardViewContainer from '@/views/storyboard/StoryboardViewContainer';
import i18n from 'i18n';

interface Story {
    id: number;
    assignedUrl: string;
    firstStoryboardHashid: string;
    firstStoryboardSlug: string;
}

const CustomersDashboardView: React.FC = React.memo(() => {
    const [personsStories, loadingPersonsStories] = useData<Story[]>(window.URLS.storiesResource, {
        storeResolver: 'personsStories',
        initialValue: [],
        requestParams: {
            params: {storyListType: 'personsStories'},
        },
    });

    if (loadingPersonsStories) {
        return <CellLoader fullHeight={true} />;
    }

    const story = personsStories.find((s: Story) => s.assignedUrl === 'customers');

    if (story) {
        return (
            <StoryboardViewContainer
                activeStoryboardHashid={story.firstStoryboardHashid}
                activeStoryUrl=""
                activeStoryboardUrl={story.firstStoryboardSlug}
                activeStoryObject=""
                hideNavigation={false}
            />
        );
    }

    return <div>{i18n.t('jt_no_storyassignedurl_configured_for_this_dashboard.text')}</div>;
});

export default CustomersDashboardView;
